var exports = {
  "Wl": "EmbedGifv.module__imagePreviewHandler___TlBjZ1",
  "tN": "EmbedGifv.module__blurContainer___TlBjZ1",
  "rj": "EmbedGifv.module__blurContent___TlBjZ1",
  "JV": "EmbedGifv.module__blurInnerContainer___TlBjZ1",
  "aO": "EmbedGifv.module__thumbHashPlaceholder___TlBjZ1",
  "il": "EmbedGifv.module__mediaContainer___TlBjZ1",
  "M_": "EmbedGifv.module__videoWrapper___TlBjZ1",
  "UD": "EmbedGifv.module__videoElement___TlBjZ1",
  "qf": "EmbedGifv.module__placeholder___TlBjZ1",
  "ci": "EmbedGifv.module__placeholderFastFade___TlBjZ1",
  "Ap": "EmbedGifv.module__placeholderVisible___TlBjZ1",
  "uR": "EmbedGifv.module__placeholderHidden___TlBjZ1",
};

module.exports = exports;
